module.exports = __webpack_public_path__ + "static/img/freight-intelligence-logo.a35cd11.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/freight-intelligence-logo.png
// module id = a5M6
// module chunks = 1